define('helpers/CommonHelper',[], function () {
  var CommonHelper = {
    ROL_ADM_MDIRECTOR_NEWFREE: 'adm_mdirector_newfree',
    ROL_ADM_MDIRECTOR: 'adm_mdirector',
    ROL_SUPER_ADM_MDIRECTOR: 'admin_mdirector',
  };

  return CommonHelper;
});

